module.exports = __webpack_public_path__ + "img/portugal.5b3a556c.svg";